import { render, staticRenderFns } from "./CoursePageInfo.vue?vue&type=template&id=dc2b2dfc&scoped=true"
import script from "./CoursePageInfo.vue?vue&type=script&lang=js"
export * from "./CoursePageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2b2dfc",
  null
  
)

export default component.exports